import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const MyCustFiltersIcon = ({
  size = 28,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 28 28"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill="#D1D9E9">
      <Path
        d="M28.426 5.346h-12.6a1.07 1.07 0 0 0-1.066 1.066c0 .587.48 1.067 1.066 1.067h12.6a1.07 1.07 0 0 0 1.067-1.067 1.07 1.07 0 0 0-1.067-1.066ZM25.12 10.465h-9.28a1.07 1.07 0 0 0-1.067 1.066c0 .587.48 1.067 1.067 1.067h9.28a1.07 1.07 0 0 0 1.067-1.067 1.07 1.07 0 0 0-1.067-1.066ZM22.213 15.506H15.84a1.07 1.07 0 0 0-1.067 1.067c0 .586.48 1.066 1.067 1.066h6.373a1.07 1.07 0 0 0 1.067-1.066 1.07 1.07 0 0 0-1.067-1.067ZM13.427 20.546 10.4 23.212v-16.8a1.07 1.07 0 0 0-1.067-1.066 1.07 1.07 0 0 0-1.067 1.066v16.8L5.24 20.546a1.072 1.072 0 0 0-1.507.093c-.387.44-.347 1.12.093 1.507l4.787 4.226c.08.067.16.12.267.174h.026a1.1 1.1 0 0 0 .414.093c.146 0 .28-.04.413-.093h.027c.093-.04.186-.107.267-.174l4.8-4.226c.44-.387.48-1.067.093-1.507a1.072 1.072 0 0 0-1.507-.093h.014Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h32v32H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)
export default MyCustFiltersIcon
